import { render } from "./EditPictureGallery.vue?vue&type=template&id=a31bdde0&scoped=true"
import script from "./EditPictureGallery.vue?vue&type=script&lang=js"
export * from "./EditPictureGallery.vue?vue&type=script&lang=js"

import "./EditPictureGallery.vue?vue&type=style&index=0&id=a31bdde0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a31bdde0"

export default script